"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertAttributeNames = exports.camelToSnake = exports.pascalToCamel = exports.isUpperCase = void 0;
function isUpperCase(str) {
    return str === str.toUpperCase();
}
exports.isUpperCase = isUpperCase;
function pascalToCamel(str) {
    if (isUpperCase(str))
        return str.toLowerCase();
    return `${str.charAt(0).toLocaleLowerCase()}${str.slice(1)}`;
}
exports.pascalToCamel = pascalToCamel;
function camelToSnake(str) {
    return `${str
        .replace(/\.?([A-Z]+)/g, function (x, y) {
        return "_" + y.toLowerCase();
    })
        .replace(/^_/, "")}`;
}
exports.camelToSnake = camelToSnake;
function convertAttributeNames(obj, converter) {
    const res = {};
    Object.keys(obj).forEach((key) => {
        res[converter(key)] = obj[key];
    });
    return res;
}
exports.convertAttributeNames = convertAttributeNames;
